// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: reader/assert_record_api.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  AssertCategoryType,
  assertCategoryTypeFromJSON,
  assertCategoryTypeToJSON,
  AssertStateType,
  assertStateTypeFromJSON,
  assertStateTypeToJSON,
} from "../models/assert";
import { StpVlanPortStateStatus, stpVlanPortStateStatusFromJSON, stpVlanPortStateStatusToJSON } from "../schema/schema";

export const protobufPackage = "reader";

/**
 * Code generated by protoc-gen-assert-history-mapper.  DO NOT EDIT.
 *
 * PROPRIETARY AND CONFIDENTIAL. Cisco Systems, Inc. considers the contents of this
 * file to be highly confidential trade secret information.
 *
 * COPYRIGHT 2024 Cisco Systems, Inc., All rights reserved.
 *
 * This file is generated, but its contents are intentionally committed to source control to allow for easier
 * "bootstrapped" builds when building from a fresh checkout.
 */

export interface UnifiedAssertRecord {
  /** Time at which the assertion were modified. */
  modifiedAt:
    | Date
    | undefined;
  /** The assert type value as set in the schema-path. */
  assertType: string;
  /** The assertion category */
  category: AssertCategoryType;
  /** The assertion state, new or resolved */
  assertState: AssertStateType;
  /** device mac address string */
  device: string;
  /** line_card as in various assert schema-paths */
  lineCard: number;
  /** breakout as in various assert schema-paths */
  breakout: number;
  /** port name as set in the assert config data. */
  portName: string;
  /** The flag indicates if the assertion is masked. */
  masked: boolean;
  /** The Org UUID as set in the assert config data. */
  orgId: string;
  /** latched_at as in all types of assert config data. */
  latchedAt:
    | Date
    | undefined;
  /** The latch_time as in all types of assert config data */
  latchTime: string;
  /** implicit assert flag as set in assert config data */
  implicit: boolean;
  /** remote_port_name is the LldpRemPortDesc stored in AssertPortLinkDown and AssertPortExpectedNeighbor */
  remotePortName: string;
  /** remote device mac address */
  remoteDevice: string;
  /** num_neighbors as in AssertPortExpectedNeighbor */
  numNeighbors: number;
  /** local_port_speed as in AssertPortConnectionSpeedMatch */
  localPortSpeed: string;
  /** last_traffic_bytes as in AssertVlanHasTraffic */
  lastTrafficBytes: string;
  /** last_traffic_bytes as in AssertVlanHasTraffic */
  recentTrafficBytes: string;
  /** last_traffic_time as in AssertVlanHasTraffic */
  lastTrafficTime:
    | Date
    | undefined;
  /** vrf as set in AssertStaticDefaultRouteExists. */
  vrf: string;
  /** vlan_state as in SchemaPathAssertConfigVlanHasTraffic. */
  vlanState: number;
  /** The management state as set in the config data. */
  managementState: string;
  /** The high_cpu_util flag as set in AssertHighSwitchResourceUsage. */
  highCpuUtil: boolean;
  /** The high_disk_util as set in AssertHighSwitchResourceUsage. */
  highDiskUtil: boolean;
  /** The high_mem_util as set in AssertHighSwitchResourceUsage. */
  highMemUtil: boolean;
  /** Unique identifier of a port within a device */
  port: string;
  /** The node uuid associated with the device */
  nodeId: string;
  /** The node uuid associated with the remote device */
  remoteNodeId: string;
  /** The fabric uuid */
  fabric: string;
  /** The database transaction id */
  txnId: string;
  /** The user defined object name.. */
  objectName: string;
  /** The type of the object that triggered the event. */
  objectType: string;
  /** The object identifier. */
  objectId: string;
  /** The object identifier of parent object. */
  parentId: string;
  /** The object identifier of child object. */
  childId: string;
  /** The user who triggered the activity event. */
  username: string;
  /** The type of user operation. */
  operation: string;
  /** The STP VLAN port state observed in AssertPortVlanStpStateConsistent. */
  observedStpVlanPortState: StpVlanPortStateStatus;
  /** The sub-interface name in AssertSubInterfaceDown. */
  subInterfaceName: string;
  /** BGP peer IP address in AssertBgpPeerEstablished. */
  peerIp: string;
  /** Expected PID from config in AssertPortPluggablePidSame. */
  expectedPid: string;
  /** Observed PID from pluggable details in AssertPortPluggablePidSame. */
  observedPid: string;
  /** Multi-site name from config in the multisite asserts. */
  multisiteName: string;
  /** Multi-site BGP peer address from config in the multisite asserts. */
  bgpPeerId: string;
  /** Minimum round-trip time in microseconds in AssertMultisiteLatencyStable. */
  minRttUs: string;
  /** Median (average) round-trip time in microseconds in AssertMultisiteLatencyStable. */
  medianRttUs: string;
  /** Maximum round-trip time in microseconds in AssertMultisiteLatencyStable. */
  maxRttUs: string;
  /** Configured MTU from config in AssertMultisiteExpectedMtu. */
  expectedMtu: string;
  /** Discovered MTU in AssertMultisiteExpectedMtu. */
  discoveredMtu: string;
  /** Standard count metric */
  rowCount: string;
}

export interface AssertHistoryApiRecord {
  assertType: string;
  unified: UnifiedAssertRecord | undefined;
}

function createBaseUnifiedAssertRecord(): UnifiedAssertRecord {
  return {
    modifiedAt: undefined,
    assertType: "",
    category: 0,
    assertState: 0,
    device: "",
    lineCard: 0,
    breakout: 0,
    portName: "",
    masked: false,
    orgId: "",
    latchedAt: undefined,
    latchTime: "0",
    implicit: false,
    remotePortName: "",
    remoteDevice: "",
    numNeighbors: 0,
    localPortSpeed: "0",
    lastTrafficBytes: "0",
    recentTrafficBytes: "0",
    lastTrafficTime: undefined,
    vrf: "",
    vlanState: 0,
    managementState: "",
    highCpuUtil: false,
    highDiskUtil: false,
    highMemUtil: false,
    port: "",
    nodeId: "",
    remoteNodeId: "",
    fabric: "",
    txnId: "",
    objectName: "",
    objectType: "",
    objectId: "",
    parentId: "",
    childId: "",
    username: "",
    operation: "",
    observedStpVlanPortState: 0,
    subInterfaceName: "",
    peerIp: "",
    expectedPid: "",
    observedPid: "",
    multisiteName: "",
    bgpPeerId: "",
    minRttUs: "0",
    medianRttUs: "0",
    maxRttUs: "0",
    expectedMtu: "0",
    discoveredMtu: "0",
    rowCount: "",
  };
}

export const UnifiedAssertRecord: MessageFns<UnifiedAssertRecord> = {
  encode(message: UnifiedAssertRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modifiedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.modifiedAt), writer.uint32(10).fork()).join();
    }
    if (message.assertType !== "") {
      writer.uint32(18).string(message.assertType);
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.assertState !== 0) {
      writer.uint32(32).int32(message.assertState);
    }
    if (message.device !== "") {
      writer.uint32(42).string(message.device);
    }
    if (message.lineCard !== 0) {
      writer.uint32(48).uint32(message.lineCard);
    }
    if (message.breakout !== 0) {
      writer.uint32(56).uint32(message.breakout);
    }
    if (message.portName !== "") {
      writer.uint32(66).string(message.portName);
    }
    if (message.masked !== false) {
      writer.uint32(72).bool(message.masked);
    }
    if (message.orgId !== "") {
      writer.uint32(82).string(message.orgId);
    }
    if (message.latchedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.latchedAt), writer.uint32(90).fork()).join();
    }
    if (message.latchTime !== "0") {
      writer.uint32(96).int64(message.latchTime);
    }
    if (message.implicit !== false) {
      writer.uint32(104).bool(message.implicit);
    }
    if (message.remotePortName !== "") {
      writer.uint32(114).string(message.remotePortName);
    }
    if (message.remoteDevice !== "") {
      writer.uint32(122).string(message.remoteDevice);
    }
    if (message.numNeighbors !== 0) {
      writer.uint32(128).uint32(message.numNeighbors);
    }
    if (message.localPortSpeed !== "0") {
      writer.uint32(136).int64(message.localPortSpeed);
    }
    if (message.lastTrafficBytes !== "0") {
      writer.uint32(144).int64(message.lastTrafficBytes);
    }
    if (message.recentTrafficBytes !== "0") {
      writer.uint32(152).int64(message.recentTrafficBytes);
    }
    if (message.lastTrafficTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastTrafficTime), writer.uint32(162).fork()).join();
    }
    if (message.vrf !== "") {
      writer.uint32(170).string(message.vrf);
    }
    if (message.vlanState !== 0) {
      writer.uint32(176).uint32(message.vlanState);
    }
    if (message.managementState !== "") {
      writer.uint32(186).string(message.managementState);
    }
    if (message.highCpuUtil !== false) {
      writer.uint32(192).bool(message.highCpuUtil);
    }
    if (message.highDiskUtil !== false) {
      writer.uint32(200).bool(message.highDiskUtil);
    }
    if (message.highMemUtil !== false) {
      writer.uint32(208).bool(message.highMemUtil);
    }
    if (message.port !== "") {
      writer.uint32(218).string(message.port);
    }
    if (message.nodeId !== "") {
      writer.uint32(226).string(message.nodeId);
    }
    if (message.remoteNodeId !== "") {
      writer.uint32(234).string(message.remoteNodeId);
    }
    if (message.fabric !== "") {
      writer.uint32(242).string(message.fabric);
    }
    if (message.txnId !== "") {
      writer.uint32(250).string(message.txnId);
    }
    if (message.objectName !== "") {
      writer.uint32(258).string(message.objectName);
    }
    if (message.objectType !== "") {
      writer.uint32(266).string(message.objectType);
    }
    if (message.objectId !== "") {
      writer.uint32(274).string(message.objectId);
    }
    if (message.parentId !== "") {
      writer.uint32(282).string(message.parentId);
    }
    if (message.childId !== "") {
      writer.uint32(290).string(message.childId);
    }
    if (message.username !== "") {
      writer.uint32(298).string(message.username);
    }
    if (message.operation !== "") {
      writer.uint32(306).string(message.operation);
    }
    if (message.observedStpVlanPortState !== 0) {
      writer.uint32(312).int32(message.observedStpVlanPortState);
    }
    if (message.subInterfaceName !== "") {
      writer.uint32(322).string(message.subInterfaceName);
    }
    if (message.peerIp !== "") {
      writer.uint32(330).string(message.peerIp);
    }
    if (message.expectedPid !== "") {
      writer.uint32(338).string(message.expectedPid);
    }
    if (message.observedPid !== "") {
      writer.uint32(346).string(message.observedPid);
    }
    if (message.multisiteName !== "") {
      writer.uint32(354).string(message.multisiteName);
    }
    if (message.bgpPeerId !== "") {
      writer.uint32(362).string(message.bgpPeerId);
    }
    if (message.minRttUs !== "0") {
      writer.uint32(368).int64(message.minRttUs);
    }
    if (message.medianRttUs !== "0") {
      writer.uint32(376).int64(message.medianRttUs);
    }
    if (message.maxRttUs !== "0") {
      writer.uint32(384).int64(message.maxRttUs);
    }
    if (message.expectedMtu !== "0") {
      writer.uint32(392).int64(message.expectedMtu);
    }
    if (message.discoveredMtu !== "0") {
      writer.uint32(400).int64(message.discoveredMtu);
    }
    if (message.rowCount !== "") {
      writer.uint32(802).string(message.rowCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnifiedAssertRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnifiedAssertRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modifiedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.assertType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.assertState = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.lineCard = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.breakout = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.masked = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.latchedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.latchTime = reader.int64().toString();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.implicit = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.remotePortName = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.remoteDevice = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.numNeighbors = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.localPortSpeed = reader.int64().toString();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.lastTrafficBytes = reader.int64().toString();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.recentTrafficBytes = reader.int64().toString();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.lastTrafficTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.vrf = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.vlanState = reader.uint32();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.managementState = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.highCpuUtil = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.highDiskUtil = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.highMemUtil = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.port = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.remoteNodeId = reader.string();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.fabric = reader.string();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.txnId = reader.string();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.objectName = reader.string();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.objectType = reader.string();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.objectId = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.childId = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.username = reader.string();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.operation = reader.string();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.observedStpVlanPortState = reader.int32() as any;
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.subInterfaceName = reader.string();
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.peerIp = reader.string();
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.expectedPid = reader.string();
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.observedPid = reader.string();
          continue;
        }
        case 44: {
          if (tag !== 354) {
            break;
          }

          message.multisiteName = reader.string();
          continue;
        }
        case 45: {
          if (tag !== 362) {
            break;
          }

          message.bgpPeerId = reader.string();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.minRttUs = reader.int64().toString();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.medianRttUs = reader.int64().toString();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.maxRttUs = reader.int64().toString();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.expectedMtu = reader.int64().toString();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.discoveredMtu = reader.int64().toString();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.rowCount = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnifiedAssertRecord {
    return {
      modifiedAt: isSet(object.modifiedAt) ? fromJsonTimestamp(object.modifiedAt) : undefined,
      assertType: isSet(object.assertType) ? globalThis.String(object.assertType) : "",
      category: isSet(object.category) ? assertCategoryTypeFromJSON(object.category) : 0,
      assertState: isSet(object.assertState) ? assertStateTypeFromJSON(object.assertState) : 0,
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      lineCard: isSet(object.lineCard) ? globalThis.Number(object.lineCard) : 0,
      breakout: isSet(object.breakout) ? globalThis.Number(object.breakout) : 0,
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      masked: isSet(object.masked) ? globalThis.Boolean(object.masked) : false,
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      latchedAt: isSet(object.latchedAt) ? fromJsonTimestamp(object.latchedAt) : undefined,
      latchTime: isSet(object.latchTime) ? globalThis.String(object.latchTime) : "0",
      implicit: isSet(object.implicit) ? globalThis.Boolean(object.implicit) : false,
      remotePortName: isSet(object.remotePortName) ? globalThis.String(object.remotePortName) : "",
      remoteDevice: isSet(object.remoteDevice) ? globalThis.String(object.remoteDevice) : "",
      numNeighbors: isSet(object.numNeighbors) ? globalThis.Number(object.numNeighbors) : 0,
      localPortSpeed: isSet(object.localPortSpeed) ? globalThis.String(object.localPortSpeed) : "0",
      lastTrafficBytes: isSet(object.lastTrafficBytes) ? globalThis.String(object.lastTrafficBytes) : "0",
      recentTrafficBytes: isSet(object.recentTrafficBytes) ? globalThis.String(object.recentTrafficBytes) : "0",
      lastTrafficTime: isSet(object.lastTrafficTime) ? fromJsonTimestamp(object.lastTrafficTime) : undefined,
      vrf: isSet(object.vrf) ? globalThis.String(object.vrf) : "",
      vlanState: isSet(object.vlanState) ? globalThis.Number(object.vlanState) : 0,
      managementState: isSet(object.managementState) ? globalThis.String(object.managementState) : "",
      highCpuUtil: isSet(object.highCpuUtil) ? globalThis.Boolean(object.highCpuUtil) : false,
      highDiskUtil: isSet(object.highDiskUtil) ? globalThis.Boolean(object.highDiskUtil) : false,
      highMemUtil: isSet(object.highMemUtil) ? globalThis.Boolean(object.highMemUtil) : false,
      port: isSet(object.port) ? globalThis.String(object.port) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      remoteNodeId: isSet(object.remoteNodeId) ? globalThis.String(object.remoteNodeId) : "",
      fabric: isSet(object.fabric) ? globalThis.String(object.fabric) : "",
      txnId: isSet(object.txnId) ? globalThis.String(object.txnId) : "",
      objectName: isSet(object.objectName) ? globalThis.String(object.objectName) : "",
      objectType: isSet(object.objectType) ? globalThis.String(object.objectType) : "",
      objectId: isSet(object.objectId) ? globalThis.String(object.objectId) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : "",
      childId: isSet(object.childId) ? globalThis.String(object.childId) : "",
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      operation: isSet(object.operation) ? globalThis.String(object.operation) : "",
      observedStpVlanPortState: isSet(object.observedStpVlanPortState)
        ? stpVlanPortStateStatusFromJSON(object.observedStpVlanPortState)
        : 0,
      subInterfaceName: isSet(object.subInterfaceName) ? globalThis.String(object.subInterfaceName) : "",
      peerIp: isSet(object.peerIp) ? globalThis.String(object.peerIp) : "",
      expectedPid: isSet(object.expectedPid) ? globalThis.String(object.expectedPid) : "",
      observedPid: isSet(object.observedPid) ? globalThis.String(object.observedPid) : "",
      multisiteName: isSet(object.multisiteName) ? globalThis.String(object.multisiteName) : "",
      bgpPeerId: isSet(object.bgpPeerId) ? globalThis.String(object.bgpPeerId) : "",
      minRttUs: isSet(object.minRttUs) ? globalThis.String(object.minRttUs) : "0",
      medianRttUs: isSet(object.medianRttUs) ? globalThis.String(object.medianRttUs) : "0",
      maxRttUs: isSet(object.maxRttUs) ? globalThis.String(object.maxRttUs) : "0",
      expectedMtu: isSet(object.expectedMtu) ? globalThis.String(object.expectedMtu) : "0",
      discoveredMtu: isSet(object.discoveredMtu) ? globalThis.String(object.discoveredMtu) : "0",
      rowCount: isSet(object.rowCount) ? globalThis.String(object.rowCount) : "",
    };
  },

  toJSON(message: UnifiedAssertRecord): unknown {
    const obj: any = {};
    if (message.modifiedAt !== undefined) {
      obj.modifiedAt = message.modifiedAt.toISOString();
    }
    if (message.assertType !== "") {
      obj.assertType = message.assertType;
    }
    if (message.category !== 0) {
      obj.category = assertCategoryTypeToJSON(message.category);
    }
    if (message.assertState !== 0) {
      obj.assertState = assertStateTypeToJSON(message.assertState);
    }
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.lineCard !== 0) {
      obj.lineCard = Math.round(message.lineCard);
    }
    if (message.breakout !== 0) {
      obj.breakout = Math.round(message.breakout);
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.masked !== false) {
      obj.masked = message.masked;
    }
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.latchedAt !== undefined) {
      obj.latchedAt = message.latchedAt.toISOString();
    }
    if (message.latchTime !== "0") {
      obj.latchTime = message.latchTime;
    }
    if (message.implicit !== false) {
      obj.implicit = message.implicit;
    }
    if (message.remotePortName !== "") {
      obj.remotePortName = message.remotePortName;
    }
    if (message.remoteDevice !== "") {
      obj.remoteDevice = message.remoteDevice;
    }
    if (message.numNeighbors !== 0) {
      obj.numNeighbors = Math.round(message.numNeighbors);
    }
    if (message.localPortSpeed !== "0") {
      obj.localPortSpeed = message.localPortSpeed;
    }
    if (message.lastTrafficBytes !== "0") {
      obj.lastTrafficBytes = message.lastTrafficBytes;
    }
    if (message.recentTrafficBytes !== "0") {
      obj.recentTrafficBytes = message.recentTrafficBytes;
    }
    if (message.lastTrafficTime !== undefined) {
      obj.lastTrafficTime = message.lastTrafficTime.toISOString();
    }
    if (message.vrf !== "") {
      obj.vrf = message.vrf;
    }
    if (message.vlanState !== 0) {
      obj.vlanState = Math.round(message.vlanState);
    }
    if (message.managementState !== "") {
      obj.managementState = message.managementState;
    }
    if (message.highCpuUtil !== false) {
      obj.highCpuUtil = message.highCpuUtil;
    }
    if (message.highDiskUtil !== false) {
      obj.highDiskUtil = message.highDiskUtil;
    }
    if (message.highMemUtil !== false) {
      obj.highMemUtil = message.highMemUtil;
    }
    if (message.port !== "") {
      obj.port = message.port;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.remoteNodeId !== "") {
      obj.remoteNodeId = message.remoteNodeId;
    }
    if (message.fabric !== "") {
      obj.fabric = message.fabric;
    }
    if (message.txnId !== "") {
      obj.txnId = message.txnId;
    }
    if (message.objectName !== "") {
      obj.objectName = message.objectName;
    }
    if (message.objectType !== "") {
      obj.objectType = message.objectType;
    }
    if (message.objectId !== "") {
      obj.objectId = message.objectId;
    }
    if (message.parentId !== "") {
      obj.parentId = message.parentId;
    }
    if (message.childId !== "") {
      obj.childId = message.childId;
    }
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.operation !== "") {
      obj.operation = message.operation;
    }
    if (message.observedStpVlanPortState !== 0) {
      obj.observedStpVlanPortState = stpVlanPortStateStatusToJSON(message.observedStpVlanPortState);
    }
    if (message.subInterfaceName !== "") {
      obj.subInterfaceName = message.subInterfaceName;
    }
    if (message.peerIp !== "") {
      obj.peerIp = message.peerIp;
    }
    if (message.expectedPid !== "") {
      obj.expectedPid = message.expectedPid;
    }
    if (message.observedPid !== "") {
      obj.observedPid = message.observedPid;
    }
    if (message.multisiteName !== "") {
      obj.multisiteName = message.multisiteName;
    }
    if (message.bgpPeerId !== "") {
      obj.bgpPeerId = message.bgpPeerId;
    }
    if (message.minRttUs !== "0") {
      obj.minRttUs = message.minRttUs;
    }
    if (message.medianRttUs !== "0") {
      obj.medianRttUs = message.medianRttUs;
    }
    if (message.maxRttUs !== "0") {
      obj.maxRttUs = message.maxRttUs;
    }
    if (message.expectedMtu !== "0") {
      obj.expectedMtu = message.expectedMtu;
    }
    if (message.discoveredMtu !== "0") {
      obj.discoveredMtu = message.discoveredMtu;
    }
    if (message.rowCount !== "") {
      obj.rowCount = message.rowCount;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnifiedAssertRecord>, I>>(base?: I): UnifiedAssertRecord {
    return UnifiedAssertRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnifiedAssertRecord>, I>>(object: I): UnifiedAssertRecord {
    const message = createBaseUnifiedAssertRecord();
    message.modifiedAt = object.modifiedAt ?? undefined;
    message.assertType = object.assertType ?? "";
    message.category = object.category ?? 0;
    message.assertState = object.assertState ?? 0;
    message.device = object.device ?? "";
    message.lineCard = object.lineCard ?? 0;
    message.breakout = object.breakout ?? 0;
    message.portName = object.portName ?? "";
    message.masked = object.masked ?? false;
    message.orgId = object.orgId ?? "";
    message.latchedAt = object.latchedAt ?? undefined;
    message.latchTime = object.latchTime ?? "0";
    message.implicit = object.implicit ?? false;
    message.remotePortName = object.remotePortName ?? "";
    message.remoteDevice = object.remoteDevice ?? "";
    message.numNeighbors = object.numNeighbors ?? 0;
    message.localPortSpeed = object.localPortSpeed ?? "0";
    message.lastTrafficBytes = object.lastTrafficBytes ?? "0";
    message.recentTrafficBytes = object.recentTrafficBytes ?? "0";
    message.lastTrafficTime = object.lastTrafficTime ?? undefined;
    message.vrf = object.vrf ?? "";
    message.vlanState = object.vlanState ?? 0;
    message.managementState = object.managementState ?? "";
    message.highCpuUtil = object.highCpuUtil ?? false;
    message.highDiskUtil = object.highDiskUtil ?? false;
    message.highMemUtil = object.highMemUtil ?? false;
    message.port = object.port ?? "";
    message.nodeId = object.nodeId ?? "";
    message.remoteNodeId = object.remoteNodeId ?? "";
    message.fabric = object.fabric ?? "";
    message.txnId = object.txnId ?? "";
    message.objectName = object.objectName ?? "";
    message.objectType = object.objectType ?? "";
    message.objectId = object.objectId ?? "";
    message.parentId = object.parentId ?? "";
    message.childId = object.childId ?? "";
    message.username = object.username ?? "";
    message.operation = object.operation ?? "";
    message.observedStpVlanPortState = object.observedStpVlanPortState ?? 0;
    message.subInterfaceName = object.subInterfaceName ?? "";
    message.peerIp = object.peerIp ?? "";
    message.expectedPid = object.expectedPid ?? "";
    message.observedPid = object.observedPid ?? "";
    message.multisiteName = object.multisiteName ?? "";
    message.bgpPeerId = object.bgpPeerId ?? "";
    message.minRttUs = object.minRttUs ?? "0";
    message.medianRttUs = object.medianRttUs ?? "0";
    message.maxRttUs = object.maxRttUs ?? "0";
    message.expectedMtu = object.expectedMtu ?? "0";
    message.discoveredMtu = object.discoveredMtu ?? "0";
    message.rowCount = object.rowCount ?? "";
    return message;
  },
};

function createBaseAssertHistoryApiRecord(): AssertHistoryApiRecord {
  return { assertType: "", unified: undefined };
}

export const AssertHistoryApiRecord: MessageFns<AssertHistoryApiRecord> = {
  encode(message: AssertHistoryApiRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assertType !== "") {
      writer.uint32(10).string(message.assertType);
    }
    if (message.unified !== undefined) {
      UnifiedAssertRecord.encode(message.unified, writer.uint32(802).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssertHistoryApiRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssertHistoryApiRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assertType = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.unified = UnifiedAssertRecord.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssertHistoryApiRecord {
    return {
      assertType: isSet(object.assertType) ? globalThis.String(object.assertType) : "",
      unified: isSet(object.unified) ? UnifiedAssertRecord.fromJSON(object.unified) : undefined,
    };
  },

  toJSON(message: AssertHistoryApiRecord): unknown {
    const obj: any = {};
    if (message.assertType !== "") {
      obj.assertType = message.assertType;
    }
    if (message.unified !== undefined) {
      obj.unified = UnifiedAssertRecord.toJSON(message.unified);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssertHistoryApiRecord>, I>>(base?: I): AssertHistoryApiRecord {
    return AssertHistoryApiRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssertHistoryApiRecord>, I>>(object: I): AssertHistoryApiRecord {
    const message = createBaseAssertHistoryApiRecord();
    message.assertType = object.assertType ?? "";
    message.unified = (object.unified !== undefined && object.unified !== null)
      ? UnifiedAssertRecord.fromPartial(object.unified)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
